import lightGallery from "lightgallery";

// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

document.addEventListener("DOMContentLoaded", () => {
  let node_gallery = document.querySelector("#node-gallery");

  //inline_galleries.forEach((gallery) => {
  if (node_gallery) {
    let nodeGallery = lightGallery(node_gallery, {
      plugins: [lgZoom, lgThumbnail],
      startClass: "",
      //container: node_gallery,
      thumbnail: true,
      // Turn off hash plugin in case if you are using it
      // as we don't want to change the url on slide change
      hash: false,
      // Do not allow users to close the gallery
      closable: true,
      // Allows clicks on black area to close gallery
      closeOnTap: true,
      // Add maximize icon to enlarge the gallery
      showMaximizeIcon: false,
      // Delay slide transition to complete captions animations
      // before navigating to different slides (Optional)
      // You can find caption animation demo on the captions demo page
      mobileSettings: {
        showCloseIcon: true,
        toggleThumb: false
      },
      preload: 8,
      controls: true,
      slideDelay: 0,
      speed: 100,
      zoomFromOrigin: false,
      download: false,
      subHtmlSelectorRelative: true,
      toggleThumb: true,
      //appendSubHtmlTo: '.lg-outer',
      allowMediaOverlap: false,
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      licenseKey: "0000-0000-000-0000",
    });
  }

  //inlineGallery.openGallery();

  //addArticleImageToGallery(updateSlideInstance);
  //});
});

const addArticleImageToGallery = (galleryInstance) => {
  /* Add slide to gallery */
  let featuredArticleImage = document.querySelector(".article-featured-image");

  let galleryItems = [
    ...[
      {
        src: featuredArticleImage.src,
        thumb: featuredArticleImage.src,
        subHtml: `<h4>${featuredArticleImage.alt}</h4><p>${featuredArticleImage.dataset.featuredImageAuthor}</p>`,
      },
    ],
    ...galleryInstance.galleryItems,
  ];

  //console.log(...galleryItems.reverse());
  galleryInstance.updateSlides(galleryItems, 1);

  //inlineGallery.openGallery();
};
